// 列表请求防竞态（从 JobList/index.tsx 抽出，便于 node:test 单测）。
// 每次发请求 begin() 领取序号；响应回来时 isLatest(seq) 为 false 说明已有更新的请求，
// 丢弃该（过期）响应，避免慢的旧请求覆盖新结果（例如收藏/删除后刷新与筛选切换交错）。
export interface LatestRequestGuard {
  begin(): number;
  isLatest(seq: number): boolean;
}

export function createLatestRequestGuard(): LatestRequestGuard {
  let current = 0;
  return {
    begin() {
      current += 1;
      return current;
    },
    isLatest(seq: number) {
      return seq === current;
    },
  };
}
